// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EJi2","question":"styles_question__1ONqQ","description":"styles_description__1lFxR"};